module.exports = __webpack_public_path__ + "static/media/balance-scale-left.c3817d16.svg";